export {default} from './UserPanel';



// WEBPACK FOOTER //
// ./src/containers/UserPanel/index.ts